module.exports = __webpack_public_path__ + "img/telegram.965dac98.svg";